/* tslint:disable */
/* eslint-disable */
/**
 * 80s Conservation Club REST API
 * 80s Conservation Club REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: graham@matthewsapps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CognitoChallengeNameSchema } from './CognitoChallengeNameSchema';
import {
    CognitoChallengeNameSchemaFromJSON,
    CognitoChallengeNameSchemaFromJSONTyped,
    CognitoChallengeNameSchemaToJSON,
} from './CognitoChallengeNameSchema';

/**
 * Create Account Request Body
 * @export
 * @interface RespondToAuthChallengeRequest
 */
export interface RespondToAuthChallengeRequest {
    /**
     * 
     * @type {CognitoChallengeNameSchema}
     * @memberof RespondToAuthChallengeRequest
     */
    challengeType: CognitoChallengeNameSchema;
    /**
     * Challenge Response Parameters
     * @type {any}
     * @memberof RespondToAuthChallengeRequest
     */
    challengeResponses: any | null;
    /**
     * Session Token
     * @type {string}
     * @memberof RespondToAuthChallengeRequest
     */
    session?: string;
    /**
     * Username
     * @type {string}
     * @memberof RespondToAuthChallengeRequest
     */
    username?: string;
}



/**
 * Check if a given object implements the RespondToAuthChallengeRequest interface.
 */
export function instanceOfRespondToAuthChallengeRequest(value: object): value is RespondToAuthChallengeRequest {
    if (!('challengeType' in value) || value['challengeType'] === undefined) return false;
    if (!('challengeResponses' in value) || value['challengeResponses'] === undefined) return false;
    return true;
}

export function RespondToAuthChallengeRequestFromJSON(json: any): RespondToAuthChallengeRequest {
    return RespondToAuthChallengeRequestFromJSONTyped(json, false);
}

export function RespondToAuthChallengeRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RespondToAuthChallengeRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'challengeType': CognitoChallengeNameSchemaFromJSON(json['challengeType']),
        'challengeResponses': json['challengeResponses'],
        'session': json['session'] == null ? undefined : json['session'],
        'username': json['username'] == null ? undefined : json['username'],
    };
}

export function RespondToAuthChallengeRequestToJSON(value?: RespondToAuthChallengeRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'challengeType': CognitoChallengeNameSchemaToJSON(value['challengeType']),
        'challengeResponses': value['challengeResponses'],
        'session': value['session'],
        'username': value['username'],
    };
}

